"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageVideoUploader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _reactDropzone = require("react-dropzone");
var _lodash = require("lodash");
var _Preview = _interopRequireDefault(require("./Preview"));
var _Icon = require("../Icon");
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ImageVideoUploader = props => {
  const {
    maxSize = 5242880,
    errors,
    name,
    isRequired = false,
    formGroupClassName,
    fileTypes = {
      "image/jpeg": [],
      "image/png": []
    },
    title = "Upload creatives here:"
  } = props;
  const [validFiles, setValidFiles] = (0, _react.useState)([]);
  const [invalidFilesErrorMsg, setInvalidFilesErrorMsg] = (0, _react.useState)("");
  let errorClass = errors && (0, _lodash.get)(errors, name) ? "is-invalid" : "is-valid";
  let updatedFormGroupClass = formGroupClassName ? `${formGroupClassName} ${errorClass}` : `${errorClass}`;
  const onDrop = (0, _react.useCallback)((acceptedFiles, rejectedFiles) => {
    /**
     * Set error message for invalid file type and size
     */
    if (rejectedFiles.length > 0) {
      let errorSize = [];
      let errorType = [];
      rejectedFiles.map(fileItem => {
        if (fileItem.errors[0].code === "file-too-large") {
          errorSize.push(fileItem.file?.name);
        } else if (fileItem.errors[0].code === "file-invalid-type") {
          errorType.push(fileItem.file?.name);
        }
      });
      setInvalidFilesErrorMsg({
        errorSize: errorSize,
        errorType: errorType
      });
    }

    /**
     * Set valid files : already uploaded + new files
     */

    if (acceptedFiles.length > 0) {
      setValidFiles(files => [...files, ...acceptedFiles.filter(file => {
        /** Ignore duplicate uploads and only return new files*/
        if (!files.some(e => e.name === file.name)) return Object.assign(file, {
          preview: URL.createObjectURL(file),
          width: "",
          height: "",
          status: "uploading",
          s3FileUrl: "",
          s3FileName: ""
        });
      })]);
    }
  }, []);
  const {
    getRootProps,
    getInputProps,
    isDragActive
  } = (0, _reactDropzone.useDropzone)({
    onDrop,
    accept: fileTypes,
    maxSize: maxSize
  });
  const removeItem = name => {
    setValidFiles(() => (0, _lodash.remove)(validFiles, file => {
      return file.name !== name;
    }));
  };
  (0, _react.useEffect)(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    // const getPresignedURL = await props?.getPresignedURL();
    // setPresignedURL(getPresignedURL);
    // return () =>
    //   validFiles.forEach((file) => URL.revokeObjectURL(file.preview));
    const completedFiles = (0, _lodash.filter)(validFiles, file => {
      return file.status === "completed";
    });
    if (props?.setValue) props?.setValue(props?.name, completedFiles);
  }, [validFiles]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Label, {
    className: "form__label",
    "aria-label": "Upload creatives here"
  }, title, isRequired && /*#__PURE__*/_react.default.createElement("span", {
    className: "asterisk"
  }, "*")), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: `upload-container upload-container--${isDragActive}`
  }, getRootProps()), /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
    "data-testid": "input"
  }, getInputProps())), /*#__PURE__*/_react.default.createElement("div", {
    className: "file-upload-wrap"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon-container icon-container--ideal"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon__wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: ["fa", "cloud-upload-alt"],
    className: `uploader--icon uploader--icon-ideal`
  }))), /*#__PURE__*/_react.default.createElement("h2", null, "Upload Files"), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", null, "Drag & Drop files here or click to upload"), /*#__PURE__*/_react.default.createElement("span", null, " PNG, JPG up to ", maxSize / 1024 / 1024, "mb")), errors && /*#__PURE__*/_react.default.createElement(_reactstrap.FormGroup, {
    className: `form-group ${updatedFormGroupClass}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "form--control__error"
  }, errors && (0, _lodash.get)(errors, name)?.message)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "invalid--files"
  }, Boolean(invalidFilesErrorMsg.errorType?.length) && /*#__PURE__*/_react.default.createElement("span", null, "Invalid files: ", invalidFilesErrorMsg.errorType.join(", "), ". Only JPG & PNG images are allowed"), Boolean(invalidFilesErrorMsg.errorSize?.length) && /*#__PURE__*/_react.default.createElement("span", null, "File size exceeded: ", invalidFilesErrorMsg.errorSize.join(", "), ". Maximum file size can be ", maxSize / 1024 / 1024, "mb.")), Boolean(validFiles.length) && /*#__PURE__*/_react.default.createElement(_Preview.default, {
    files: validFiles,
    removeItem: removeItem,
    setValue: props?.setValue,
    name: props?.name,
    params: props?.params
  }));
};
exports.ImageVideoUploader = ImageVideoUploader;